import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { map } from 'rxjs';

@Directive({
  selector: '[appTerminateGuard]'
})
export class TerminateGuardDirective {

  
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService,
  ) {}

  @Input() set appTerminateGuard(moduleName: string) {
      this.authService.getUserPermissionsOnModules(moduleName)
      .subscribe((response) => {
          const pqiAllModules = response.find(
            (res) => res.readWrite === true 
          );
  
          if (pqiAllModules) {
                  this.viewContainer.createEmbeddedView(this.templateRef);
                  this.hasView = true;
          } else {
                  this.viewContainer.clear();
                  this.hasView = false;
          }
        }
      );
    

  }

}
